// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"96a963e8","996":"ed9d9eac"}[chunkId] + ".chunk.js";
};